/* eslint-disable no-unused-vars */
export enum SocialMediaProviderType {
  Facebook = 1,
  Google = 2,
  Twitter,
}
